<template>
  <div class="Login__Page">
    <div class="is-flex is-flex-direction-row-reverse">
      <div class="Login__Page__Figure">
        <div class="img-responsive">
          <img v-if="portal === 'uti'" src="@/assets/uti_logo_blue.png" alt="" />
          <img v-else src="@/assets/login.svg" alt="" />
        </div>
      </div>
      <div class="
          Login__Page__Form
          p-6
          is-flex is-flex-direction-row is-align-items-center
        ">
        <div v-if="portal === 'sosna' && currentStep === LOGIN_STEPS.CREDENTIALS" class="portal-image">
          <img src="../assets/Sosna.jpg" alt="">
        </div>
        <section v-if="currentStep === LOGIN_STEPS.CREDENTIALS" class="is-flex is-flex-direction-column">
          <h1 v-if="portal === 'sosna'">ברוכים הבאים לפורטל סוסנה 👋</h1>
          <h1 v-if="portal === 'uti'">ברוכים הבאים ל-UTI 👋</h1>
          <h1 v-else>ברוכים הבאים ל Betterway 👋</h1>
          <h3 class="subtitle">
            להתחברות למערכת יש להקליד את שם המשתמש וסיסמא
          </h3>
          <form @submit.prevent="login">
            <b-field label="אימייל">
              <b-input placeholder="" v-model="email" type="email" validation-message="כתובת המייל שהוזנה אינה תקנית"
                icon-right="close-circle" icon-right-clickable @icon-right-click="clearIconClick">
              </b-input>
            </b-field>

            <b-field label="סיסמא">
              <b-input type="password" v-model="password" placeholder="" password-reveal>
              </b-input>
            </b-field>
            <b-message type="is-danger" v-if="loginError">
              {{ loginError }}
            </b-message>
            <b-message type="is-danger" v-if="userLocked">
              חלו יותר מדי טעויות בזיהוי - המשתמש ננעל לדקה
            </b-message>
            <b-button :loading="loading" :disabled="loading" native-type="submit" type="is-primary">התחברות
              למערכת</b-button>
            <router-link :to="{ name: 'Forgot', query: { email } }">שכחתי סיסמה</router-link>
            <span class="or-separator">או</span>
            <div class="signin-buttons">
              <b-button type="button" class="custom-microsoft-signin-btn" :disabled="loadingMicrosoft"
                :loading="loadingMicrosoft" @click="handleMicrosoftLogin">
                <svg class="ms-btn-icon" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="#F25022" d="M1 1h10v10H1z" />
                  <path fill="#7FBA00" d="M13 1h10v10H13z" />
                  <path fill="#00A4EF" d="M1 13h10v10H1z" />
                  <path fill="#FFB900" d="M13 13h10v10H13z" />
                </svg><span class="ms-btn-text">כניסה באמצעות Microsoft</span>
              </b-button>
              <div id="google-login-btn" :disabled="loadingGoogle" :loading="loadingGoogle">
              </div>
            </div>
          </form>
        </section>
        <section v-if="currentStep === LOGIN_STEPS.OTP" class="is-flex is-flex-direction-column">
          <OtpInput :invalidOTP="invalidOTP" :resendCooldown="resendCooldown" @submit="verifyOTP"
            @resend="resendOTP" @clear-otp-error="invalidOTP = false"/>
        </section>
      </div>
    </div>
    <CookiePopup v-show="false"/>
  </div>
</template>

<script>
import OtpInput from '@/components/OtpInput.vue';
import CookiePopup from '@/components/CookiePopup.vue';

const LOGIN_STEPS = {
  CREDENTIALS: 'credentials',
  OTP: 'otp'
};

export default {
  components: {
    OtpInput,
    CookiePopup
  },

  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      loginError: null,
      loading: false,
      userLocked: false,
      portal: null,
      loadingMicrosoft: false,
      loadingGoogle: false,

      // OTP step
      LOGIN_STEPS,
      currentStep: LOGIN_STEPS.CREDENTIALS, // 'credentials' or 'otp'
      otpErrorCode: "OtpRequired",
      otpErrorDesc: "OTP code was sent",
      otpCode: "",
      invalidOTP: false,
      loadingOTP: false,
      resendCooldown: 0,
      resendTimer: null,
      // Store credentials for OTP step
      storedCredentials: null,
    };
  },
  created() {
    if (window.location.host.split('.')[0].includes('sosna')) this.portal = 'sosna';
    if (window.location.host.split('.')[0].includes('colmobil')) this.portal = 'colmobil';
    if (window.location.host.split('.')[0].includes('caspa')) this.portal = 'caspa';
    if (window.location.host.split('.')[0].includes('uti')) this.portal = 'uti';
  },
  mounted() {
    this.loadGoogleScript().then(() => {
      this.initGoogleAuth();
    }).catch((error) => {
      console.error('Google script failed to load:', error);
    });
  },
  beforeDestroy() {
    if (this.resendTimer) {
      clearTimeout(this.resendTimer);
    }
  },
  methods: {
    loadGoogleScript() {
      // eslint-disable-next-line no-undef
      return new Promise((resolve, reject) => {
        // If already loaded, resolve immediately
        // eslint-disable-next-line no-undef
        if (window.google && window.google.accounts) {
          resolve();
          return;
        }
        // Load the script
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client?hl=he';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
        script.onload = () => {
          const startTime = Date.now();
          // Wait for window.google.accounts to be available
          const checkGoogleAccounts = () => {
            if (window.google && window.google.accounts) {
              resolve();
            } else if (Date.now() - startTime > 5000) {
              reject(new Error('Google script failed to load'));
            } else {
              setTimeout(checkGoogleAccounts, 50);
            }
          };
          checkGoogleAccounts();
        };
      });
    },
    initGoogleAuth() {
      // eslint-disable-next-line no-undef
      const googleAuth = window.google.accounts.id;
      googleAuth.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: this.handleGoogleCredentialResponse,
        nonce: Math.random().toString(36).substring(2, 15),
        ux_mode: 'popup',
      });
      googleAuth.renderButton(document.getElementById('google-login-btn'), {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        logo_alignment: 'left',
        text: 'signin_with',
        locale: 'he',
        shape: 'rectangular',
        width: 600,
      });
    },
    searchIconClick() {
      alert("You wanna make a search?");
    },
    clearIconClick() {
      this.email = "";
    },
    login() {
      this.storedCredentials = { email: this.email, password: this.password };
      this.loading = true;
      this.resetErrorFlags();
      this.$auth
        .login({
          email: this.email,
          password: this.password,
        })
        .then(() => {
          if (this.isAdminWithoutProfileId) {
            this.$router.replace({ name: "admin" });
          } else {
            this.$router.replace({ name: "dashboard" });
          }
        })
        .catch((err) => {
          // Check if server requires OTP
          if (this.isOtpRequired(err)) {
            this.currentStep = LOGIN_STEPS.OTP;
            this.$nextTick(() => {
              if (this.$refs.otpInput && this.$refs.otpInput[0]) {
                this.$refs.otpInput[0].focus();
              }
            });
            this.startResendOtpCooldown();
          } else {
            this.handleLoginError(err);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyOTP(otpCode) {
      this.invalidOTP = false;
      this.$auth
        .verifyOTP({
          email: this.storedCredentials?.email || this.email,
          otpCode
        })
        .then(() => {
          // OTP verification success
          this.storedCredentials = null;
          if (this.isAdminWithoutProfileId) {
            this.$router.replace({ name: "AdminProfiles" });
          } else {
            this.$router.replace({ name: "AdminProfiles" });
          }
        })
        .catch((err) => {
          console.error('OTP verification failed:', err);
          this.invalidOTP = true;
        });
    },
    backToCredentials() {
      this.currentStep = LOGIN_STEPS.CREDENTIALS;
      this.otpCode = "";
      this.invalidOTP = false;
      this.resetErrorFlags();
    },
    resendOTP() {
      if (this.resendCooldown > 0) return;
      this.$auth
        .login(this.storedCredentials)
        .then(() => {
          // This should trigger OTP step again
          this.currentStep = LOGIN_STEPS.OTP;
          this.$nextTick(() => {
            if (this.$refs.otpInput && this.$refs.otpInput[0]) {
              this.$refs.otpInput[0].focus();
            }
          });
          this.startResendOtpCooldown();
        })
        .catch((err) => {
          if (this.isOtpRequired(err)) {
            this.currentStep = LOGIN_STEPS.OTP;
            this.$nextTick(() => {
              if (this.$refs.otpInput && this.$refs.otpInput[0]) {
                this.$refs.otpInput[0].focus();
              }
            });
            this.startResendOtpCooldown();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    startResendOtpCooldown() {
      this.resendCooldown = 30; // 30 seconds
      this.resendTimer = setInterval(() => {
        this.resendCooldown -= 1;
        if (this.resendCooldown <= 0) {
          clearInterval(this.resendTimer);
          this.resendTimer = null;
        }
      }, 1000);
    },
    async handleGoogleCredentialResponse(response) {
      try {
        await this.$auth.googleLogin(response.credential);
        this.$router.replace({ name: "AdminProfiles" });
      } catch (error) {
        this.handleLoginError(error, 'חשבון Google');
      } finally {
        this.loadingGoogle = false;
      }
    },
    async handleMicrosoftLogin() {
      this.loadingMicrosoft = true;
      this.resetErrorFlags();
      try {
        const response = await this.$msal.authenticatePopup({
          scopes: ['User.Read'],
        });
        if (response && response.account) {
          // Get the ID token
          await this.$auth.microsoftLogin(response.idToken);
          this.$router.replace({ name: "AdminProfiles" });
        }
      } catch (error) {
        this.handleLoginError(error, 'חשבון Microsoft');
      } finally {
        this.loadingMicrosoft = false;
      }
    },
    resetErrorFlags() {
      this.loginError = null;
      this.userLocked = false;
    },
    isOtpRequired(err) {
      return err.response && err.response.status === 400 &&
        err.response.data.error === this.otpErrorCode &&
        err.response.data.error_description === this.otpErrorDesc;
    },
    handleLoginError(error, loginType = 'regular') {
      this.loginError = null;
      // Map server errors to user-friendly Hebrew messages
      const errorMessages = {
        "The user name or password is incorrect.": "שם משתמש או סיסמא אינם נכונים.",
        "User locked out due to too many failed attempts. Try again later.": "חלו יותר מדי טעויות בזיהוי - המשתמש ננעל לדקה",
        // Add more specific mappings as needed
      };

      if (error?.response?.data?.error_description) {
        // Server returned specific error description
        const serverError = error.response.data.error_description;
        this.loginError = errorMessages[serverError] || `שגיאה בהתחברות: ${serverError}`;
      } else if (error?.message && error.message.includes('Network Error')) {
        // Network connectivity issues
        this.loginError = "שגיאת רשת - אנא בדוק את החיבור לאינטרנט";
      } else {
        this.loginError = loginType === 'regular'
          ? "שגיאה בהתחברות"
          : `שגיאה בהתחברות באמצעות ${loginType}`;
      }

      if (error?.response?.data?.error_description === "User locked out due to too many failed attempts. Try again later.") {
        this.userLocked = true;
      }
    },
  },
  computed: {
    isAdminWithoutProfileId() {
      return !this.$store.state.auth.profileId && this.$store.state.auth?.user?.claims?.isAdmin === "True";
    }
  }
};
</script>

<style lang="scss">
.Login__Page {
  &>div {
    height: 100vh;
  }
}

.Login__Page__Form {
  flex: 0 1 600px;
  flex-direction: column !important;
  justify-content: center !important;

  section {
    width: 100%;

    h1 {
      font-size: 25px;
      text-align: right;
    }

    .subtitle {
      margin: 5px 0 20px 0;
      font-size: 17px;
      color: #7b7b7b;
    }

    .label {
      font-size: 15px;
      font-weight: normal;
      color: #505050;

      &:not(:last-child) {
        margin: 0;
      }
    }

    input {
      direction: ltr;
    }

    button {
      margin: 10px 0;
      width: 100%;
    }

    .message-body {
      border-width: 0 4px 0 0;
      padding: 0.6em 0.6em;
    }
  }
}

.Login__Page__Figure {
  flex: 1 1 300px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signin-buttons {
  display: flex;
  flex-direction: column;
  align-items: center; // <-- This centers children horizontally
  width: 100%;
}

.custom-microsoft-signin-btn {
  width: 400px !important;
  height: 40px !important;
  letter-spacing: 0.25px !important;
  font-family: "Rubik", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #4f5154 !important;
  border: 1px solid #dadce0 !important;
  border-radius: 4px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 12px 0 !important;
  -webkit-font-smoothing: antialiased !important;
  transition: background-color .218s, border-color .218s !important;

  .ms-btn-text {
    font-family: "Rubik", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
    text-align: center;
    z-index: 1;
    font-size: inherit !important;
    font-weight: inherit !important;
    text-overflow: ellipsis !important;
    margin-right: 30px;
  }

  .ms-btn-icon {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }
}

.custom-microsoft-signin-btn:active {
  background: #e8f0fe !important;
  color: #3c4043 !important;
}

.custom-microsoft-signin-btn:hover {
  background-color: #f0f5fe !important;
  box-shadow: none !important;
  cursor: pointer !important;
  border-color: #dadce0 !important;
}

.or-separator {
  display: block;
  text-align: center;
  margin: 2px 0;
  color: #7b7b7b;
}

.forgot-password-container {
  text-align: right;
}

.forgot-password-link {
  text-decoration: none;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
}

@media (max-width: 600px) {
  .Login__Page__Figure {
    display: none !important;
  }
}
</style>
